import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { createPhoto } from "../../api/const";
import ActivitySearch from "../../components/const/Photo/ActivitySearch"

const Photo_new = ({ isOpen, onClose, onCreated }) => {
  const [photos, setPhotos] = useState([]);
  const { id: projectId } = useParams();
  if (!isOpen) return null; // 모달 닫힘 시 렌더링 안함

  // 파일 추가 (input 또는 드래그)
  const handleFiles = (files) => {
    const newPhotos = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file), // 미리보기용 blob URL
      title: "",
      activity_id: "",
      description: "",
    }));
    setPhotos((prev) => [...prev, ...newPhotos]);
  };

  const handleFileChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // 메타데이터 변경
  const handleMetaChange = (index, field, value) => {
    setPhotos((prev) =>
      prev.map((p, i) => (i === index ? { ...p, [field]: value } : p))
    );
  };

  // 제출
  const handleSubmit = async () => {
    try {
      const result = await createPhoto(
        photos.map((p) => ({
          ...p,
          project: projectId,
          activity_id: p.activity?.id || null,  // id만 추출
        }))
      );
      console.log("업로드 성공:", result);
      alert("사진이 업로드되었습니다.");
      setPhotos([]);
      if (onCreated) onCreated();
      onClose();
    } catch (error) {
      console.error("업로드 실패:", error);
      alert("업로드 중 오류가 발생했습니다.");
    }
  };


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl p-6">
        {/* 헤더 */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">시공사진 등록</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        {/* 드래그 영역 */}
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center mb-4 cursor-pointer hover:border-blue-400"
        >
          <p className="text-gray-500">여기에 사진을 드래그하거나 클릭해서 선택하세요</p>
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
            id="photo-upload"
          />
          <label
            htmlFor="photo-upload"
            className="mt-2 inline-block px-4 py-2 bg-blue-500 text-white rounded cursor-pointer hover:bg-blue-600"
          >
            파일 선택
          </label>
        </div>

        {/* 파일 목록 */}
        <div className="max-h-[400px] overflow-y-auto space-y-4 pr-2">
          {photos.map((photo, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-2 gap-4 border rounded-lg shadow-sm bg-gray-50 p-4"
            >
              {/* 좌측: 미리보기 */}
              <div className="flex items-center justify-center">
                <img
                  src={photo.preview}
                  alt={`preview-${index}`}
                  className="max-h-48 object-contain rounded-md border"
                />
              </div>

              {/* 우측: 메타데이터 */}
              <div>
                <input
                  type="text"
                  placeholder="제목"
                  value={photo.title}
                  onChange={(e) =>
                    handleMetaChange(index, "title", e.target.value)
                  }
                  className="border p-2 w-full mb-2 rounded-md"
                />
                {/* Activity 검색 .. 보류 */}
                {/* <ActivitySearch
                  value={photo.activity}   // 선택된 activity 객체 (없으면 null)
                  onChange={(activity) =>
                    handleMetaChange(index, "activity", activity) // 전체 객체 저장
                  }
                /> */}
                <textarea
                  placeholder="설명"
                  value={photo.description}
                  onChange={(e) =>
                    handleMetaChange(index, "description", e.target.value)
                  }
                  className="border p-2 w-full mb-2 rounded-md"
                  rows={3}
                />
              </div>
            </div>
          ))}
        </div>

        {/* 제출 버튼 */}
        <div className="flex justify-end mt-4">
          <button
            onClick={handleSubmit}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            업로드
          </button>
        </div>
      </div>
    </div>
  );
};

export default Photo_new;
